import {Select, styled} from "@mui/material";

export const NSelect = styled(Select)(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    '& .MuiSelect-select': {
        color: theme.palette.text.primary,
    },
    '& .MuiSelect-icon': {
        color: theme.palette.text.primary,
    },
}));